"use client";

import { createContext, useContext, useState } from "react";

interface Service {
  selectedDay: string | null;
  setSelectedDay: (day: string | null) => void;
}

const noop: Service = {
  selectedDay: null,
  setSelectedDay: () => undefined,
};

const dayCtx = createContext<Service>(noop);

export function useSelectedDay(): Service {
  return useContext(dayCtx);
}

export function SelectedDayProvider(props: { children: React.ReactNode }) {
  const [selectedDay, setSelectedDay] = useState<string | null>(null);

  return (
    <dayCtx.Provider value={{ selectedDay, setSelectedDay }}>
      {props.children}
    </dayCtx.Provider>
  );
}
